import type { ResultOf, VariablesOf } from "gql.tada";
import { graphql } from "@/data-access/graphql";

export const GetNewsFeedStaticFilterQuery = graphql(`
  query getNewsFeedStaticFilterQuery(
    $projectionFilters: FeedArticleProjectionFilter
    $categories: [ShareVoiceSidebarCategory!]!
  ) {
    newsFeedSidebar(
      projectionFilters: $projectionFilters
      categories: $categories
    ) {
      category
      categoryLabel
      total
    }
  }
`);

export const GetNewsFeedDynamicFilterQuery = graphql(`
  query getNewsFeedDynamicFiltersQuery(
    $projectionFilters: FeedArticleProjectionFilter
    $categories: [ShareVoiceSidebarCategory!]!
  ) {
    newsFeedDynamicSidebar(
      projectionFilters: $projectionFilters
      categories: $categories
    ) {
      category
      id
      label
      total
      groupId
    }
  }
`);

export type NewsFeedSidebarResult = ResultOf<
  typeof GetNewsFeedStaticFilterQuery
>;
export type NewsFeedSidebarVariables = VariablesOf<
  typeof GetNewsFeedStaticFilterQuery
>;

export type NewsFeedDynamicSidebarResult = ResultOf<
  typeof GetNewsFeedDynamicFilterQuery
>;

export type NewsFeedSidebarFilterItem =
  NewsFeedSidebarResult["newsFeedSidebar"][number];

export type NewsFeedDynamicSidebarFilterItem =
  NewsFeedDynamicSidebarResult["newsFeedDynamicSidebar"][number];

export type NewsFeedFilterCategory = NonNullable<
  NewsFeedSidebarVariables["categories"]
>[number];
